import { object } from "zod";

export const deleteNetSuiteIntegration = {
  name: "deleteNetSuiteIntegration" as const,
  input: object({}),
  output: object({}),
};
